// extracted by mini-css-extract-plugin
export default {"wrapper":"ClanStarsDivisions_wrapper_b737a","divider":"ClanStarsDivisions_divider_df2c4"};